let inject = [
   '$scope',
   '$state',
   '$rootScope',
   'SharedService',
   'ngAuthSettings'
 ];
 
 class CategoriesSynchronousFilterController{
   constructor ($scope, $state, $rootScope, SharedService, ngAuthSettings) {
     this.$state = $state;
     this.$scope = $scope;
     this.ngAuthSettings = ngAuthSettings;
     this.$rootScope = $rootScope;
     this.SharedService = SharedService;
   }
   
 }
 
 CategoriesSynchronousFilterController.$inject = inject;
 
 export default CategoriesSynchronousFilterController;
 
 


/** WEBPACK FOOTER **
 ** ./www/components/catalog/categories-filter/categories-synchronous-filter/categories-synchronous-filter.controller.js
 **/